import { render, staticRenderFns } from "./LgFinderPageBanco.vue?vue&type=template&id=33f1aafc"
import script from "./LgFinderPageBanco.vue?vue&type=script&lang=js"
export * from "./LgFinderPageBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports